import { render, staticRenderFns } from "./createCardForm.vue?vue&type=template&id=728eadb6&"
import script from "./createCardForm.vue?vue&type=script&lang=js&"
export * from "./createCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports